import { PlusCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './empty-state.styled'

interface EmptyStateProps {
  onAddEssential?: () => void
  insideFolder?: boolean
}

// TODO: with reusable empty state component and remove this one
export const EmptyState = ({ onAddEssential, insideFolder }: EmptyStateProps) => {
  const { t } = useTranslation(['community-essentials'])

  return (
    <S.Container>
      <S.Image alt={t('community-essentials:emptyState.imageAlt')} src="/images/no-results.svg" />
      <S.Title>
        <Typography as="span" size="heading-medium" weight="semibold">
          {insideFolder
            ? t('community-essentials:emptyState.title.folder')
            : t('community-essentials:emptyState.title.root')}
        </Typography>
      </S.Title>
      <S.Description>
        <Typography as="span" size="text-medium" color="black500">
          {insideFolder
            ? t('community-essentials:emptyState.description.folder')
            : t('community-essentials:emptyState.description.root')}
        </Typography>
      </S.Description>
      {onAddEssential && (
        <Button size="medium" onClick={onAddEssential}>
          {t('community-essentials:addEssential')}
          <Icon icon={PlusCircleIcon} size="1.6rem" />
        </Button>
      )}
    </S.Container>
  )
}
